var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-container"},[_c('ul',{staticClass:"steps"},_vm._l((_vm.steps),function(index,key){return _c('li',{key:key,class:['step', { active: _vm.currentIndex(index)}]},[_c('span',[_vm._v(" "+_vm._s(index))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }